import { URLS } from "../API/API endpoints";
import axiosInstance from "../AxiosInstance";
import i18next from "i18next";

export const getUOM = async () => {
  try {
    const payload = {
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
    };
    const response = await axiosInstance.post(URLS.GET_UOM, payload);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getInventoryallcategories = async (user_id, store_id) => {
  try {
    const payload = {
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
      user_id: user_id,
      company_id: store_id,
    };
    const response = await axiosInstance.post(
      URLS.GET_RETAILER_PRODUCT_CATEGORY,
      payload,
    );

    // console.log("responsse data", response.data);

    return response.data?.result[0]?.response;
  } catch (error) {
    return error;
  }
};

export const getInventorydashboard = async (user_id) => {
  try {
    const payload = {
      user_id: user_id,
    };
    const response = await axiosInstance.post(
      URLS.GET_INVENTORY_DASHBOARD,
      payload,
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getInventoryallproducts = async (
  user_id,
  store_id,
  categoryId,
  group_id,
  productName,
  limit = 10,
  offset = 0,
  is_discounted,
  is_loose,
  barcode,
) => {
  try {
    const payload = {
      user_id: user_id,
      company_id: store_id,
      categ_id:
        categoryId === 0 || categoryId === undefined ? false : categoryId,
      group_id: group_id === 0 || group_id === undefined ? false : group_id,
      product_name: productName,
      limit: limit,
      offset: offset,
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
      discounted_price: is_discounted,
      is_loose: is_loose,
      barcode: barcode,
    };

    const response = await axiosInstance.post(URLS.GET_ALL_PRODUCTS, payload);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getInventoryOutLowHigh = async (
  user_id,
  store_id,
  categoryId,
  group_id,
  selectedInventoryTile,
  productName,
  limit = 10,
  offset = 0,
) => {
  try {
    const payload = {
      user_id: user_id,
      company_id: store_id,
      type: selectedInventoryTile,
      categ_id:
        categoryId === 0 || categoryId === undefined ? false : categoryId,
      group_id: group_id === 0 || group_id === undefined ? false : group_id,
      product_name: productName,
      limit: limit,
      offset: offset,
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
    };

    const response = await axiosInstance.post(URLS.GET_OUT_LOW_HIGH, payload);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getInventoryincompleteproducts = async (
  user_id,
  store_id,
  limit = 10,
  offset = 0,
) => {
  try {
    const payload = {
      user_id: user_id,
      company_id: store_id,
      limit: limit,
      offset: offset,
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
    };
    const response = await axiosInstance.post(
      URLS.GET_INCOMPLETE_PRODUCTS,
      payload,
    );

    console.log("INCOMPLEET", response.data.result[0]);

    return response.data.result[0].products;
  } catch (error) {
    return error;
  }
};

// export const getInventoryallproducts = async (limit = 10, offset = 0) => {
//
// try {
//       const payload = {
//         user_id:login.user?.userDetails?.user_id,
//        store_id:login.user?.RetailerDetails?.[0]?.id,
//         limit: limit,
//         offset: offset,
//       };
//       const response = await axiosInstance.post(
//         URLS.GET_ALL_PRODUCTS,
//         payload
//       );
//       ;

//       return response.data;
//     } catch (error) {
//       return error;
//     }
//   };

export const InventorySearch = async (
  user_id,
  store_id,
  value,
  limit = 10,
  offset = 0,
) => {
  try {
    // user_id:login.user?.userDetails?.user_id,
    const payload = {
      store_id: store_id,
      query: value ? value : "",
      limit: limit,
      offset: offset,
    };
    const response = await axiosInstance.post(URLS.SEARCH_INVENTORY, payload);

    return response.data;
  } catch (error) {
    return error;
  }
};
export const StockoutSearch = async (
  user_id,
  store_id,
  value,
  limit = 10,
  offset = 0,
) => {
  try {
    // user_id:login.user?.userDetails?.user_id,
    const payload = {
      store_id: store_id,
      query: value ? value : "",
      limit: limit,
      offset: offset,
    };
    const response = await axiosInstance.post(
      URLS.STOCKOUT_SEARCH_INVENTORY,
      payload,
    );
    return response.data;
  } catch (error) {
    return error;
  }
};
export const HighonInventorySearch = async (
  user_id,
  store_id,
  value,
  limit = 10,
  offset = 0,
) => {
  try {
    // user_id:login.user?.userDetails?.user_id,
    const payload = {
      store_id: store_id,
      query: value ? value : "",
      limit: limit,
      offset: offset,
    };
    const response = await axiosInstance.post(
      URLS.HIGHON_SEARCH_INVENTORY,
      payload,
    );

    return response.data;
  } catch (error) {
    return error;
  }
};
export const LowonInventorySearch = async (
  user_id,
  store_id,
  value,
  limit = 10,
  offset = 0,
) => {
  try {
    // user_id:login.user?.userDetails?.user_id,
    const payload = {
      store_id: store_id,
      query: value ? value : "",
      limit: limit,
      offset: offset,
    };
    const response = await axiosInstance.post(
      URLS.LOWON_SEARCH_INVENTORY,
      payload,
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

export const InventorySearchonboard = async (name) => {
  try {
    // console.log("Nme", name);

    // if (isInteger(name)) {
    //   barcode = name;
    //   name = "";
    // }
    // user_id:login.user?.userDetails?.user_id,
    const payload = {
      // user_id: user_id,
      // store_id: store_id,
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
      product_name: name,
      // barcode: barcode,
      limit: 20,
      offset: 0,

      // query: value ? value : "",
      // limit: limit,
      // offset: offset,
    };
    const response = await axiosInstance.post(
      URLS.SEARCH_INVENTORY_ONBOARD,
      payload,
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

export const InventorySearchonboardBarcode = async (name) => {
  try {
    // console.log("Nme", name);

    // if (isInteger(name)) {
    //   barcode = name;
    //   name = "";
    // }
    // user_id:login.user?.userDetails?.user_id,
    const payload = {
      // user_id: user_id,
      // store_id: store_id,
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
      barcode: name,
      // barcode: barcode,
      limit: 10,
      offset: 0,

      // query: value ? value : "",
      // limit: limit,
      // offset: offset,
    };
    const response = await axiosInstance.post(
      URLS.SEARCH_INVENTORY_ONBOARD,
      payload,
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

export const InventoryProductRequest = async (
  user_id,
  values,
  costPrice,
  salePrice,
  discountedPrice,
) => {
  // console.log("API VALUEEESSS", values);

  try {
    // user_id:login.user?.userDetails?.user_id,
    const payload = {
      user_id: user_id,
      // store_id: store_id,
      product_name: values?.name?.trim() || "",
      product_name2: values?.custom_name?.trim() || "",
      // egs_code : values?.egs_code?.trim() || "",
      product_shortcut: values?.productShortcut?.trim() || "",
      barcode: values?.barcode?.trim() || "",
      sale_price: Number(salePrice),
      cost_price: Number(costPrice),
      discounted_price: Number(discountedPrice),
      onhand_qty: Number(values?.quantity),
      uom_id: values?.product_uom,
      machine_barcode: values?.product_code,
      // image_url: values?.image_url,
      gs_data: values?.is_gs1,
      add_group_ids: values.groups ? values.groups : [],
      tax_id:values?.taxId,
      is_tax_price_inclusive:values?.isinclusive == true ? true : false,
    };
    const response = await axiosInstance.post(URLS.PRODUCT_REQUEST, payload);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const InventoryCategoryFilter = async (
  user_id,
  store_id,
  category = [],
  subcategory = [],
  query = "",
  report_for = 1,
  limit = 10,
  offset = 0,
) => {
  try {
    // user_id:login.user?.userDetails?.user_id,
    const payload = {
      user_id: user_id,
      store_id: store_id,
      category_id: category,
      sub_category_id: subcategory,
      query: query,
      request_for: report_for,
      limit: limit,
      offset: offset,
    };

    const response = await axiosInstance.post(URLS.CATEGORY_FILTER, payload);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const InventoryAddproduct = async (user_id, store_id, values) => {
  try {
    // user_id:login.user?.userDetails?.user_id,

    const payload = {
      user_id: user_id,
      store_id: store_id,
      product_id: values?.product_id,
      // barcode:values?.barcode,
      cost_price: values?.cost_price,
      sale_price: values?.sale_price,
      qty: values?.qty,
    };

    const response = await axiosInstance.post(URLS.ADD_PRODUCT, payload);

    return response.data;
  } catch (error) {
    return error;
  }
};

// export const InventoryUpdateDetails = async (
//   // user_id,
//   // store_id,
//   // product_ids
// ) => {
//   try {
//     // user_id:login.user?.userDetails?.user_id,

//     const payload = {
//       // user_id: user_id,
//       // store_id: store_id,
//       // product_ids: product_ids,
//     };

//     const response = await axiosInstance.post(
//       URLS.UPDATE_STORE_PRODUCT_DETAIL,
//       payload
//     );

//     // console.log("Update Product Data", response);

//     return response.data;
//   } catch (error) {
//     return error;
//   }
// };

export const InventoryUpdateDetailsIncomplete = async (val, store_id) => {
  try {
    const payload = {
      company_id: store_id,
      product_list: val.map((product) => ({
        product_id: product.product_id,
        sales_price: JSON.parse(product.sales_price),
        cost_price: JSON.parse(product.cost_price),
      })),
    };

    const response = await axiosInstance.post(
      URLS.UPDATE_STORE_INCOMPLETE_PRODUCT_DETAIL,
      payload,
    );

    return response.data;
  } catch (error) {
    console.error("Error in API call:", error);
    throw error; // Re-throw the error to handle it in the calling function
  }
};

export const InventoryUpdateDetails = async (item) => {
  try {
    // Construct the payload with the item details
    console.log("item", item);

    const payload = {
      quant_id: item.quant_id,
      new_price: item.new_price,
      new_cost_price: item.new_cost_price,
      new_quantity: item.new_quantity,
      machine_barcode: item.machine_barcode,
      secondary_barcode: String(item.secondary_barcode),
      discounted_price: item.discounted_price,
      product_name2:
        item?.product_name2?.trim() === "" ? "" : item?.product_name2?.trim(),
      egs_code: item?.egs_code,
      add_group_ids:item?.group_ids,
      remove_group_ids:item?.remove_group_ids,
      product_shortcut: item?.product_shortcut,
      // If user_id and store_id are needed, you can include them here
      // user_id: user_id,
      // store_id: store_id,
    };

    const response = await axiosInstance.post(
      URLS.UPDATE_STORE_PRODUCT_DETAIL,
      payload,
    );

    return response.data;
  } catch (error) {
    console.error("Error in API call:", error);
    throw error; // Re-throw the error to handle it in the calling function
  }
};

export const GenerateExcelReport = async (user_id, store_id, val) => {
  try {
    // user_id:login.user?.userDetails?.user_id,

    const payload = {
      user_id: user_id,
      store_id: store_id,
      report_for: val,
    };

    const response = await axiosInstance.post(URLS.INVENTORY_REPORT, payload, {
      responseType: "blob", // Set responseType to 'blob' to receive binary data
    });

    // Create a blob object from the response data
    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Create a downloadable URL for the blob
    const url = window.URL.createObjectURL(blob);

    // Create a temporary <a> element to trigger the download
    const link = document.createElement("a");
    link.href = url;
    link.download = "inventory_report.xlsx"; // Set the desired file name

    // Append the <a> element to the DOM and trigger the download
    document.body.appendChild(link);
    link.click();

    // Clean up by removing the <a> element and revoking the URL
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    return response;
  } catch (error) {
    return error;
  }
};

export const getProductlog = async (user_id, store_id, product_id) => {
  try {
    const payload = {
      user_id: user_id,
      store_id: store_id,
      product_id: product_id,
    };
    const response = await axiosInstance.post(
      URLS.GET_INVENTORY_PRODUCT_LOGS,
      payload,
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

// export const fetchGS1 = async (user_id, barcode) => {
//   try {
//     const payload = {
//       user_id: user_id,
//       gtin: barcode,
//     };
//     const response = await axiosInstance.post(URLS.FETCH_GS1_DATA, payload);
//     return response?.data;
//   } catch (error) {
//     return error;
//   }
// };

export const uploadImage = async (productId, base64Image) => {
  const extension = base64Image.split(";")[0].split("/")[1];
  const filename = `${productId}.${extension}`;
  const base64Data = base64Image.split(",")[1];
  // console.log("BASE CHALA", base64Data);

  const payload = {
    filename: filename,
    bucket: process.env.REACT_APP__PRODUCT_IMAGE_BUCKET,
    data: base64Data,
  };

  try {
    const response = await axiosInstance.post(
      process.env.REACT_APP__IMAGE_UPLOAD,
      payload,
      {},
    );

    if (
      response.data &&
      response.data.result &&
      response.data.result.status_code === 200
    ) {
      return response.data.result.url;
    } else {
      console.error("Upload failed:", response.data);
      return null;
    }
  } catch (error) {
    console.error("Error uploading image:", error);
    return null;
  }
};

export const uploadImageUrl = async (productId, primaryImageUrl) => {
  const payload = {
    product_id: productId,
    primary_image_url: primaryImageUrl,
    secondary_image_urls: [],
  };

  try {
    const response = await axiosInstance.post(
      URLS.PROD_UPLOAD_IMAGE_URLS,
      payload,
    );

    console.log("uploadImageUrl response:", response.data);

    // Check the response structure
    if (
      response.data &&
      response.data.result &&
      response.data.result[0].status_code === 200
    ) {
      console.log("Image URL uploaded successfully:", response.data.result[0]);
      return true; // Indicate success
    } else {
      console.error("Image URL upload failed:", response.data);
      return false; // Indicate failure
    }
  } catch (error) {
    console.error("Error uploading image URL:", error);
    return false; // Indicate failure
  }
};

export const updateGsProductRequest = async (userId, productData) => {
  const payload = {
    user_id: userId,
    product_data: productData,
  };

  const headers = {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  try {
    const response = await axiosInstance.post(
      URLS.UPDATE_GS_PRODUCT_REQUEST,
      payload,
      { headers },
    );

    console.log("updateGsProductRequest response:", response.data);

    if (response.data && response.data.status_code === 200) {
      console.log("GS1 Product request updated successfully:", response.data);
      return true; // Indicate success
    } else {
      console.error("Failed to update GS1 Product request:", response.data);
      return false; // Indicate failure
    }
  } catch (error) {
    console.error("Error updating GS1 Product request:", error);
    return false; // Indicate failure
  }
};

export const UploadBulkInventory = async (payload) => {
  try {
    const response = await axiosInstance.post(
      process.env.REACT_APP_API_URL_2 + URLS.UPLOAD_BULK_INVENTORY_NEW,
      payload,
    );
    // console.log("HFGFKF",response?.data);

    return response?.data;
  } catch (error) {
    return error;
  }
};

export const getProductInfo = async (companyId, productId) => {
  try {
    const payload = {
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
      company_id: companyId,
      product_id: Number(productId),
    };
    const response = await axiosInstance.post(URLS.GET_PROD_INFO, payload);
    return response.data?.result[0];
  } catch (error) {
    return error;
  }
};

export const getProductHistory = async (companyId, productId, offset, limit) => {
  try {
    const payload = {
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
      company_id: companyId,
      product_id: Number(productId),
      "limit":limit,
    "offset":offset,
    };
    const response = await axiosInstance.post(URLS.GET_PRODUCT_HISTORY, payload);
    return response.data?.result[0];
  } catch (error) {
    return error;
  }
};

export const getAllStoreProductInformation = async (companyId, productId) => {
  try {
    const payload = {
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
      company_id: companyId,
      product_id: Number(productId),
    };
    const response = await axiosInstance.post(
      URLS.GET_ALL_STORE_PROD_INFO,
      payload,
    );
    return response.data?.result[0];
  } catch (error) {
    return error;
  }
};

export const getProductPurchaseInfo = async (
  companyId,
  productId,
  limit,
  offset,
  startDate,
  endDate,
  vendorName,
) => {
  try {
    const payload = {
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
      company_id: companyId,
      product_id: Number(productId),
      limit: limit,
      offset: offset,
      start_date: startDate,
      end_date: endDate,
      vendor_name: vendorName,
    };
    const response = await axiosInstance.post(
      URLS.GET_PROD_PURCHASE_DATA,
      payload,
    );
    return response.data?.result[0];
  } catch (error) {
    return error;
  }
};

export const getProductSalePurchaseInfo = async (companyId, productId) => {
  try {
    const payload = {
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
      company_id: companyId,
      product_id: Number(productId),
      // limit: limit,
      // offset: offset,
      // start_date: startDate,
      // end_date: endDate,
      // vendor_name: vendorName
    };
    const response = await axiosInstance.post(
      URLS.GET_PROD_SALE_PURCHASE_DATA,
      payload,
    );
    return response.data?.result;
  } catch (error) {
    return error;
  }
};

export const getProductSaleInfo = async (
  companyId,
  productId,
  limit,
  offset,
  startDate,
  endDate,
  customerName,
) => {
  try {
    const payload = {
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
      company_id: companyId,
      product_id: Number(productId),
      limit: limit,
      offset: offset,
      start_date: startDate,
      end_date: endDate,
      customer_name: customerName,
    };
    const response = await axiosInstance.post(URLS.GET_PROD_SALE_DATA, payload);
    return response.data?.result[0];
  } catch (error) {
    return error;
  }
};

export const DownloadInventoryAPI = async (payload) => {
  try {
    const response = await axiosInstance.post(URLS.EXPORT_INVENTORY, payload);
    return response?.data;
  } catch (error) {
    console.error("DownloadInventoryAPI Error:", error);
    return null;
  }
};

export const getBukUploadHistory = async (payload) => {
  try {
    const response = await axiosInstance.post(
      process.env.REACT_APP_API_URL_2 + URLS.GET_BULK_UPLOAD_HOSTORY,
      payload,
    );
    console.log("GET_POS_SESSION_HISTORY", response);

    return response?.data;
  } catch (error) {
    return error;
  }
};

export const getInventoryEditResttriction = async (id) => {
  try {
    const response = await axiosInstance.post(
      URLS.GET_STORE_USER_ACCESS_RIGHTS,
      { user_id: id },
    );
    // console.log("GET_POS_SESSION_HISTORY", response);

    return response?.data;
  } catch (error) {
    return error;
  }
};

export const verifyInventoryPassword = async (id, pass) => {
  try {
    const response = await axiosInstance.post(URLS.VERIFY_INVENTORY_PASSWORD, {
      user_id: id,
      inventory_password: pass,
    });
    // console.log("GET_POS_SESSION_HISTORY", response);

    return response?.data;
  } catch (error) {
    return error;
  }
};
